import Invoice from './Invoice'
import InvoiceDetails from './InvoiceDetails'

export const ROUTES = [
  {
    component: Invoice,
    isPublic: true,
    path: '/invoice',
    slug: 'invoices',
    title: 'invoices',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: InvoiceDetails,
    isPublic: true,
    path: '/invoice/detail/:id',
    slug: 'invoices',
    title: 'invoices',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
]
